import { ChatMessage } from '@assets/component/ChatMessage/ChatMessage';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { ChatMessageData } from '@assets/model/RagAPI';
import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import * as style from './ChatContainer.module.less';
import { last } from 'lodash';
import { LoadingAnimation } from '@assets/component/LoadingAnimation/LoadingAnimation';
interface ChatContainerProps {
    companyId: string;
}

export const ChatContainer = observer((p: ChatContainerProps) => {
    //use id to fetch chat
    const messageData: ChatMessageData[] = useStore().reportChatHistory;

    const keys = Object.keys(messageData).sort();

    const reportId = useStore().selectedReportId;
    const messages = [];

    var isLastMessageMe = false;
    keys.forEach(msgId => {
        const msg: ChatMessageData = messageData[msgId];
        if (msg.isMe) {
            isLastMessageMe = true;
            messages.push(<ChatMessage msg={msg} key={msgId} msgId={msgId} />);

            if (msg.response) {
                isLastMessageMe = false;
                const msgResponse: ChatMessageData = {
                    isMe: false,
                    message: msg.response,
                    date: new Date(),
                    processed: true,
                    raw: msg.raw
                };
                messages.push(
                    <ChatMessage
                        msg={msgResponse}
                        key={msgId + '_response'}
                        msgId={msgId}
                    />
                );
            }
        } else {
            messages.push(
                <ChatMessage msg={msg} key={msgId + '_server'} msgId={msgId} />
            );
        }
    });

    if (isLastMessageMe) {
        messages.push(
            <div className="fade-in" key="animation">
                <LoadingAnimation width={200} height={100} />
            </div>
        );
    }
    return (
        <Flex direction="column" justify="end">
            {messages}
        </Flex>
    );
});
